export function createVisibleSectionIndexSet(): Set<number> {
  return new Set<number>();
}

export function updateVisibleSectionIndexSet(
  visibleSectionIndices: Set<number>,
  sectionIndex: number,
  isVisible: boolean,
): Set<number> {
  const nextVisibleSectionIndices = new Set(visibleSectionIndices);

  if (isVisible) {
    nextVisibleSectionIndices.add(sectionIndex);
  } else {
    nextVisibleSectionIndices.delete(sectionIndex);
  }

  return nextVisibleSectionIndices;
}

export function getLastVisibleSectionIndex(
  visibleSectionIndices: Set<number>,
): number | undefined {
  let lastVisibleSectionIndex: number | undefined;

  for (const index of visibleSectionIndices) {
    if (
      lastVisibleSectionIndex === undefined ||
      index > lastVisibleSectionIndex
    ) {
      lastVisibleSectionIndex = index;
    }
  }

  return lastVisibleSectionIndex;
}
